import { useEffect, useState } from "react";
import Loading from "src/components/ui/Loading";
import { useLoading } from "src/context/LoadingContext";
import * as MatStyled from "@mui/material/styles";
import styled from "styled-components";
import device from "src/styles/device";
import { Grid } from "@mui/material";
import Button from "src/components/core/Button";
import { useParams } from "react-router-dom";
import { getCertificateDetail } from "src/api/certificate";
import { useNavigate } from "react-router-dom";
const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: "100%",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(1),
  },
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

const Container = styled.div`
  width: 100%;
  max-width: 1240px;
  position: relative;
  padding: 32px;
  margin: 0 auto;

  @media ${device.tabletL} {
    padding: 24px 20px;
  }

  @media ${device.mobileL} {
    padding: 16px;
  }
`;

const Header = styled.div`
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  display: inline-block;
  width: 100%;
  text-align: center;

  @media ${device.tabletL} {
    font-size: 1rem;
  }
`;

const Panel = styled.div`
  border-radius: 24px;
  border: 1px solid var(--Grey-stroke, #d8d8dc);
  background: var(--White, #fff);
  display: flex;
  margin: 0 auto;
  padding: 30px 24px 40px 24px;
  width: 100%;
  max-width: 1152px;

  @media ${device.tabletL} {
    padding: 0px 40px;
    border: none;
  }
  @media ${device.mobileL} {
    padding: 0 24px;
  }
`;

const WrapImage = styled.div`
  width: 200px;
  height: 200px;
  position: relative;
  background: #f5f5f5;
  border-radius: 16px;
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: inherit;
`;

const Topic = styled.span`
  color: ${({ condition, required }) =>
    condition ? "#6C6C70" : required ? "#E13B30" : "#252525"};
  font-family: Prompt;
  font-size: 1.15rem;
  font-style: normal;
  font-weight: 500;
  margin-left: ${({ condition }) => condition && "10px"};

  @media ${device.tabletL} {
    font-size: 1rem;
  }
`;

const Description = styled.span`
  color: #6c6c70;
  font-family: Prompt;
  font-size: 1.15rem;
  font-style: normal;
  font-weight: 400;
  margin-top: 8px;

  @media ${device.tabletL} {
    font-size: 0.875rem;
  }
`;

const CertificateDetail = ({ open }) => {
  const { certificateId } = useParams();
  const navigate = useNavigate();

  const [certificate, setCertificate] = useState({
    name: "",
    description: "",
    icon: "",
  });
  const { isLoading, setLoading } = useLoading();

  useEffect(() => {
    setLoading(true);
    const fetchCertificateDetail = async () => {
      try {
        const data = await getCertificateDetail(certificateId);
        setCertificate(data);
        // Handle the fetched data as needed
      } catch (error) {
        console.error("Error fetching certificate detail:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCertificateDetail();
  }, [certificateId, setLoading]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Main open={open}>
      <DrawerHeader />

      <Container>
        <Header>รายละเอียดใบรับรอง</Header>
      </Container>

      <Panel>
        <Grid container spacing={2}>
          <Grid item xs={12} mx="auto" justifyContent="center" display="flex">
            <WrapImage>
              <Image src={certificate.icon} alt="certificate" />
            </WrapImage>
          </Grid>

          <Grid item xs={12}>
            <Grid container xs={6} my={4} direction="column" mx="auto">
              <Grid item xs={12} my={2} direction="column">
                <Topic>ชื่อใบรับรอง:</Topic>

                <Description>{certificate.name}</Description>
              </Grid>

              <Grid item xs={12} my={2}>
                <Topic>รายละเอียดใบรับรอง : </Topic>

                <Description>{certificate.description}</Description>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            mx="auto"
            justifyContent="center"
            display="flex"
            mt={4}
          >
            <Button
              variant="contained"
              size="extraLarge"
              onClick={() => {
                navigate(`/certificate/edit/${certificateId}`);
              }}
              sx={{ width: "100%", maxWidth: 160, borderRadius: 4, mx: 2 }}
            >
              แก้ไขข้อมูลใบรับรอง
            </Button>
          </Grid>
        </Grid>
      </Panel>
    </Main>
  );
};

export default CertificateDetail;
